'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive Slider
 * ROLE: slider | ARIA: aria-valuenow, aria-valuemin, aria-valuemax, aria-label/aria-labelledby
 * KEYBOARD: ArrowLeft/ArrowRight (or ArrowDown/ArrowUp) adjust value by step;
 *           Home/End jump to min/max
 * FOCUS: thumb receives focus
 * LIVE-REGION: none (aria-valuenow change announced by AT)
 * PRM: thumb transition instant
 * FORCED-COLORS: track = ButtonText; range = Highlight; thumb border = ButtonText
 * RTL: ArrowLeft/ArrowRight semantics flip in RTL via Radix dir prop
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/slider/
 * SUBSTRATE: @radix-ui/react-slider
 */
import * as RadixSlider from '@radix-ui/react-slider';
import styles from './Slider.module.css';
export function Slider({ value, defaultValue, onValueChange, onValueCommit, min = 0, max = 100, step = 1, disabled = false, orientation = 'horizontal', ...ariaProps }) {
    return (_jsxs(RadixSlider.Root, { value: value, defaultValue: defaultValue, onValueChange: onValueChange, onValueCommit: onValueCommit, min: min, max: max, step: step, disabled: disabled, orientation: orientation, className: styles.root, "data-orientation": orientation, ...ariaProps, children: [_jsx(RadixSlider.Track, { className: styles.track, children: _jsx(RadixSlider.Range, { className: styles.range }) }), (value ?? defaultValue ?? [0]).map((_, i) => (_jsx(RadixSlider.Thumb, { className: styles.thumb }, i)))] }));
}
//# sourceMappingURL=Slider.js.map